module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "meetings-no-show-flow"
    }
  }, [_c('div', {
    staticClass: "light-gray-text light-text"
  }, [_vm._v("Em caso de \"No Show\" de um lead, deseja enviá-lo para um fluxo?"), _c('br'), _vm._v("Se sim, digite o nome do fluxo abaixo ou clique no campo para um selecionar um."), _c('div', {
    staticClass: "interations row"
  }, [_c('div', {
    staticClass: "col-md-6 contact-list-item-flow"
  }, [_c('flows', {
    staticClass: "field",
    attrs: {
      "user_id": _vm.selected_user,
      "default_flow": _vm.default_flow
    },
    on: {
      "flow-selected": _vm.selectFlow
    }
  })], 1), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Salvar")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ae0c2e26!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/meetings/no_show_flow.vue
// module id = 1204
// module chunks = 1